import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AgeCalculator"] */ "/workspace/src/components/age-calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dashboard"] */ "/workspace/src/components/dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeToggle"] */ "/workspace/src/components/theme-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserMenu"] */ "/workspace/src/components/user-menu.tsx");
